
import PropTypes from 'prop-types'
import React from 'react'
import { color as colors } from 'ui/variables'
import classnames from 'classnames'
import { Done, Cross } from '@segment/icons/react'
import './checklist.css'

const List = props => (
  <ul className='CheckList'>
    {props.children}
  </ul>
)

const Item = props => {
  const { isChecked, text } = props
  const icon = getIcon(isChecked)

  const iconClasses = classnames({
    'CheckListItem-icon': true,
    isChecked
  })

  return (
    <li className='CheckListItem' data-unchecked={!isChecked}>
      <div className={iconClasses}>
        {icon}
      </div>
      <div className='CheckListItem-text'>
        {text}
      </div>
    </li>
  )
}

function getIcon (isChecked) {
  if (isChecked) return <Done color={colors.green[500]} />
  return <Cross color={colors.pink[500]} />
}

List.propTypes = {
  children: PropTypes.array.isRequired
}

List.displayName = 'List'

Item.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired
}

Item.displayName = 'Item'

export { List, Item }



// WEBPACK FOOTER //
// ./ui/checklist.js